// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container__2j7NA","leftContainer":"App_leftContainer__33xZK","rightContainer":"App_rightContainer__1Oc6G","audioWaveCanvas":"App_audioWaveCanvas__2jSr7"};